import axios from 'axios';
import {  getLaropayBaseUrl } from '../config';
import { API_VERSION, APP_CONFIG_ENDPOINT, APP_LIST_ENDPOINT, GATE_CONFIG_ENDPOINT, REQUEST_OTP_ENDPOINT, VERIFY_OTP_ENDPOINT } from './endpoints';

export const requestOTP = (userid, appInfo, url) => {
    let data = JSON.stringify({ userid: userid });
    let config = {
        method: 'post',
        url: `${url}${REQUEST_OTP_ENDPOINT}${API_VERSION}`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios(config);
}


export const verifyOTP = (hash, otp, appInfo, url) => {
    let data = JSON.stringify({ hash, otp });
    let config = {
        method: 'post',
        url: `${url}${VERIFY_OTP_ENDPOINT}${API_VERSION}`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios(config);
}

export const getAppList = () => {
    let config = {
        method: 'post',
        url: `${getLaropayBaseUrl()}${APP_LIST_ENDPOINT}${API_VERSION}`,
        headers: {
            'Content-Type': 'application/json'
        }
    };

    return axios(config);
}

export const getConfig = () => {
    let config = {
        method: 'post',
        url: `${getLaropayBaseUrl()}${APP_CONFIG_ENDPOINT}${API_VERSION}`,
        headers: {
            'Content-Type': 'application/json'
        }
    };

    return axios(config);
}
export const getGateConfig = (gate) => {
    let data = JSON.stringify({name: gate})
    let config = {
        method: 'post',
        url: `${getLaropayBaseUrl()}${GATE_CONFIG_ENDPOINT}${API_VERSION}`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios(config);
}